import { Avatar } from '@mui/material'
import CrossIcon from '../../../asserts/images/Close.svg'

const TemplateDialogCloseButton = ({ onClick }) => {
  return <Avatar onClick={onClick} src={CrossIcon} alt="cross" className="closeIcon" />
}

export default TemplateDialogCloseButton
